import { render } from "./BatchClassAttributesForm.vue?vue&type=template&id=69df36b1&scoped=true&ts=true"
import script from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"

import "./BatchClassAttributesForm.vue?vue&type=style&index=0&id=69df36b1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69df36b1"]])

export default __exports__